module.exports = __webpack_public_path__ + "entry-150bfe9b/background-register-section-ca42fca1b3783132f8c91c552a64c739.webp";